<template>
  <div class="layout">
    <aside class="layout__aside" />
    <main class="layout__main">
      <slot />
    </main>
  </div>
</template>
